<template>
  <ImageHeader :imageSource="require('../assets/leeb-images3/pic1.jpg')" :headerTitle="$t('views.payments.title.receivedPayments')">
    <v-card elevation="0">
      <v-card-title>{{ $t("views.payments.title.payments") }}</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="paymentDataHeaders"
          :items="paymentDataEntries"
          :loading="!paymentDataLoaded"
          :hide-default-footer="true"
          :hide-default-header="false"
          :item-key="'AbasEntryId'"
        >
          <template v-slot:[`item.BookingDate`]="{ item }">
            <span>{{ $d(Date.parse(item.BookingDate), 'short') }}</span>
          </template>
          <template v-slot:[`item.Amount`]="{ item }">
            <span>{{ $n(item.Amount, 'currency', 'de-DE') }}</span>
          </template>
          <template slot="body.append" v-if="paymentDataLoaded">
            <tr><td></td><th>{{ $t("views.payments.paymentsTable.sum") }}</th></tr>
            <tr>
              <td><b>{{ $t("views.payments.paymentsTable.gross") }}</b></td>
              <td><b>{{ $n(getTotalAmount(), 'currency', 'de-DE') }}</b></td>
            </tr>
            <tr>
              <td><b>{{ $t("views.payments.paymentsTable.net") }}</b></td>
              <td><b>{{ $n(balanceDataValue, 'currency', 'de-DE') }}</b></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </ImageHeader>
</template>

<script>
import ImageHeader from '../components/ImageHeader.vue'
import apiClient from '../plugins/CustomerPortalApiClient/client';

export default {
  name: 'Payments',
  components: {
    ImageHeader
  },
  data: () => ({
    paymentDataEntries: [],
    paymentDataLoaded: false,
    balanceDataValue: 0,
    balanceDataLoaded: false,
  }),
  computed: {
    paymentDataHeaders: {
      get: function() {
        return [
          {text: this.$t("views.payments.paymentsTable.header.bookingDate"), value: 'BookingDate', sortable: false},
          {text: this.$t("views.payments.paymentsTable.header.amount"), value: 'Amount', sortable: false}
        ]
      }
    }
  },
  methods: {
    getTotalAmount() {
      let result = 0;
      this.paymentDataEntries.forEach(x => result += x.Amount);
      return result;
    },
    loadPayments() {
      apiClient
        .loadPayments(this.$store.getters.token(), this.$store.getters.customerNumber())
        .then((payments) => {
          this.paymentDataEntries = payments;
          this.paymentDataLoaded = true;
        }).catch((error) => {
          console.log(error);
          this.$snackbar(this.$t("views.payments.errors.loadingPayments"), 'red darken-1');
        });
    },
    loadCustomerBalance() {
      apiClient
        .loadProfileBalance(this.$store.getters.token(), this.$store.getters.customerNumber())
        .then((balance) => {
          this.balanceDataValue = balance;
          this.balanceDataLoaded = true;
        }).catch((error) => {
          console.log(error);
          this.$snackbar(this.$t("views.payments.errors.loadingProfileBalance"), 'red darken-1');
        });
    },
  },
  created() {
    this.loadPayments();
    this.loadCustomerBalance();
  }
};
</script>
